import numeral from 'numeral';

export class NumberFormatValueConverter {
	toView(value: any, format: any) {
		return numeral(value).format(format);
	}

	fromView(stringValue: any) {
		return numeral().unformat(stringValue);
	}
}
